<template>
  <SoDatePicker
    v-model="selectedDate"
    :max-date="maxDate"
    :min-date="minDate"
    :type="'daterange'"
    class="news-feed-date-picker"
  />
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoDatePicker from "@/components/formControls/SoDatePicker.vue"

  export default defineComponent({
    components: {
      SoDatePicker,
    },
    props: {
      minDate: {
        type: [Date, String] as PropType<Date | string>,
        default: null,
        required: false,
      },
      maxDate: {
        type: [Date, String] as PropType<Date | string>,
        default: null,
        required: false,
      },
    },
    emits: ["update-feeds"],
    data() {
      return {
        selectedDate: null as null | Date,
      }
    },
    watch: {
      selectedDate(newVal) {
        let filterDate = ""

        if (newVal) {
          filterDate = newVal
        }
        this.$emit("update-feeds", filterDate)
      },
    },
  })
</script>
<style scoped>
  .news-feed-date-picker {
    width: 260px;
    flex-shrink: 1;
  }
  .news-feed-date-picker :deep(.v-field--variant-solo) {
    min-width: unset;
  }
</style>
